export const PolicyPayer = {
  Worker: "worker",
  Company: "company",
} as const;
export type PolicyPayer = (typeof PolicyPayer)[keyof typeof PolicyPayer];
